import bdjs from "@bd-core/bdjs";
import $ from "jquery";
import videojs from "video.js";
import Storage from "@bd-utils/storage";
import { getCurrentPageId } from "@bd-stores/user-progress";
import Wallet from "@bd-utils/wallet";
import CompletionPopup from "@bd-utils/completion-popup";
import { getFinalTeamAnswers, getRoomStatus } from "@bd-stores/game-progress";

export default class OutroVideoRoom {
    constructor() {
        this.$app = $(".app");
        this.$outroVideo = $(".videobox.outro-video");
        this.videoOutro = null;

        this.$continueBtn = ".js-completionPopup-continue";

        this.wallet = new Wallet();
        this.completionPopup = new CompletionPopup();
    }

    initForRoom(room, videoId = null) {

        const roomID = getCurrentPageId();
        const hasSeen = this._getHasSeen(roomID);
        if (hasSeen) return;

        const roomStatus = getRoomStatus(roomID);
        if(roomStatus == "is-status-completed") {
            const finalRoomAnswers = getFinalTeamAnswers(roomID);
            this.completionPopup.show(roomID, false, finalRoomAnswers);
            return;
        }

        const $outroVideo = $('.videobox.outro-video');
        if($outroVideo.length === 0) return;

        // If videoId is provided, use it, otherwise construct from room
        const finalVideoId = videoId || `outro-video-${room}`;

        this.videoOutro = videojs(finalVideoId, {
            controls: true,
            autoplay: false,
            preload: 'auto'
        });

        this.videoOutro.on("loadeddata", () => {
            const tracks = this.videoOutro.textTracks();

            const track = tracks[0];
            if (!track) return;

            const cues = track.cues;
            if (cues.length === 0) return;

            const applyCueStyles = () => {
                const activeCueElements = this.videoOutro
                    .el()
                    .querySelectorAll(".vjs-text-track-cue");
                activeCueElements.forEach((el) => {
                    const htmlEl = /** @type {HTMLElement} */ (el);
                    const innerDiv = htmlEl.querySelector("div");
                    if (innerDiv) {
                        innerDiv.style.background = "transparent";
                        innerDiv.style.color = "#ffffff";
                        innerDiv.style.textShadow =
                            "0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0 0 12px rgba(0, 0, 0, 0.5)";
                    }
                });
            };

            let timeupdateTimeout = null;
            this.videoOutro.on("timeupdate", () => {
                if (timeupdateTimeout) {
                    clearTimeout(timeupdateTimeout);
                }
                timeupdateTimeout = setTimeout(() => {
                    applyCueStyles();
                }, 100);
            });

            setTimeout(applyCueStyles, 100);

            for (let i = 0; i < cues.length; i++) {
                const cue = cues[i];
                cue.onenter = () => {
                    setTimeout(applyCueStyles, 0);
                };
            }

            this.videoOutro.on("texttrackchange", () => {
                applyCueStyles();
            });

            const textTrackDisplay = this.videoOutro
                .el()
                .querySelector(".vjs-text-track-display");
            if (textTrackDisplay) {
                const observer = new MutationObserver(() => {
                    applyCueStyles();
                });
                observer.observe(textTrackDisplay, {
                    childList: true,
                    subtree: true,
                });
            }
        });

        this.videoOutro.on("ended", () => {
            this._setHasSeen(roomID);
            $outroVideo.removeClass("is-open");
            this.$app.removeAttr("style");

            this.videoOutro.dispose();
            this.videoOutro = null;

            const finalRoomAnswers = getFinalTeamAnswers(roomID);
            this.completionPopup.show(roomID, false, finalRoomAnswers);
        });

        this.videoOutro.on("error", () => {
            $outroVideo.removeClass("is-open");
            this.$app.removeAttr("style");
        });

        return this.videoOutro;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.outro_videos) states.outro_videos = [];
        states.outro_videos.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.outro_videos && states.outro_videos.includes(roomId);
    }

    maybeResetState(roomId) {
        if (!this._getHasSeen(roomId)) return false;

        let states = Storage.get("states", {});
        if (!states?.outro_videos) states.outro_videos = [];

        const initialLength = states.outro_videos.length;
        const outro_videos = bdjs.removeItemArray(states.outro_videos, roomId);

        if (outro_videos.length !== initialLength) {
            states.outro_videos = outro_videos;
            return Storage.set("states", states);
        }

        return false;
    }

    startVideo(onVideoStart) {
        if (this.videoOutro) {
            this.$outroVideo.addClass("is-open");
            this.$app.css({ position: "relative", zIndex: 3 });

            if(onVideoStart && typeof onVideoStart === 'function') {
                onVideoStart();
            }
            this.videoOutro.play();
        } else {
            const roomID = getCurrentPageId();
            this._setHasSeen(roomID);
        }
    }

    cleanup() {
        if (this.videoOutro) {
            this.videoOutro.dispose();
            this.videoOutro = null;
        }
        this.$outroVideo.removeClass("is-open");
        this.$app.removeAttr("style");
    }
}
